import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditStockModuleContext from 'contexts/EditStockModuleContext';
import { StockProductionCenter } from 'types/models/StockReceipt';
import { getStockProductionCenter } from 'services/stockProductionCenterServices';
import StockProductionCenterForm from 'forms/StockProductionCenterForm';

export default (): JSX.Element => {
  const { t } = useTranslation();
  const history = useHistory();
  const { selectedProductionCenter } = React.useContext(EditStockModuleContext);
  const [completeProductionCenter, setCompleteProductionCenter] = React.useState<StockProductionCenter | null>(null);

  React.useEffect(() => {
    if (!selectedProductionCenter) {
      history.replace('/private/stock/production-centers');
      return;
    }

    let mounted = true;

    (async () => {
      const completeData = await getStockProductionCenter(selectedProductionCenter.id);

      if (!mounted) return;

      if (!completeData) {
        history.replace('/private/stock/production-centers');
        return;
      }

      setCompleteProductionCenter(completeData);
    })();

    return () => {
      mounted = false;
    };
  }, [selectedProductionCenter, history]);

  if (!selectedProductionCenter) return <></>;
  if (!completeProductionCenter) return <div>{t('loading')}</div>;

  return <StockProductionCenterForm productionCenter={completeProductionCenter} />;
};
